import { FlashUIComponent } from "@goodgamestudios/core";

import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;
import Point = createjs.Point;
import Shape = createjs.Shape;

export class HotspotUIComponent extends FlashUIComponent {
    private _hotspotPoint: Point;
    private _sprite: Container;
    private _defaultRadius: number = NaN;
    private _rect: Container;
    private _spotlight: Shape;

    constructor(disp: DisplayObject, hotspotPoint: Point, defaultRadius: number) {
        super(disp);

        this._hotspotPoint = hotspotPoint;
        this._sprite = disp as Container;
        this._defaultRadius = defaultRadius;

        this._spotlight = new Shape();
        this._spotlight.compositeOperation = "destination-out";

        this._rect = new Container();

        this._sprite.addChild(this._rect);
        this._sprite.addChild(this._spotlight);
    }

    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            this.drawCircleHole(this._defaultRadius);
        }
    }

    public drawCircleHole(radius: number): void {
        this._rect.graphics.clear();
        this._rect.graphics.beginFill(0x000000, 0.8);
        this._rect.graphics.drawRect(0, 0, this.disp.stage.stageWidth, this.disp.stage.stageHeight);
        this._rect.graphics.endFill();

        this._spotlight.graphics.clear();
        this._spotlight.graphics.beginFill(0xffffff, 0.8);
        this._spotlight.graphics.drawCircle(this.layoutManager.gameNullPoint + (this._hotspotPoint.x * this.layoutManager.scaleFactor), this._hotspotPoint.y * this.layoutManager.scaleFactor, radius * this.layoutManager.scaleFactor);
        this._spotlight.graphics.endFill();
    }

    public set hotspotPoint(hotspotPoint: Point) {
        this._hotspotPoint = hotspotPoint;
    }

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
}
import { Poker2LayoutManager } from "../../../Poker2LayoutManager";
